import type { UseMutationOptions } from '@tanstack/react-query';
import { mutationOptions } from '@tanstack/react-query';

import { BRAND_SERVICE_VERSION_HEADERS } from '@/constants/environments';
import apiClient from '@/constants/http';

import type { JoinWaitlistPayload, JoinWaitlistResponse } from './types';

async function joinWaitlist(payload: JoinWaitlistPayload) {
  const { data } = await apiClient.post<JoinWaitlistResponse>(
    '/v1/customer/waiting-list',
    payload,
    {
      timeout: 20000,
      headers: BRAND_SERVICE_VERSION_HEADERS,
    },
  );

  return data;
}

export const joinWaitlistMutation = (
  options?: UseMutationOptions<
    JoinWaitlistResponse,
    Error,
    JoinWaitlistPayload
  >,
) =>
  mutationOptions({
    ...options,
    retry: false,
    mutationKey: ['joinWaitlist'],
    mutationFn: (data: JoinWaitlistPayload) => joinWaitlist(data),
  });
